import { render, staticRenderFns } from "./Corporates.vue?vue&type=template&id=132f602c&scoped=true&"
import script from "./Corporates.vue?vue&type=script&lang=js&"
export * from "./Corporates.vue?vue&type=script&lang=js&"
import style0 from "./Corporates.vue?vue&type=style&index=0&id=132f602c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132f602c",
  null
  
)

export default component.exports